import { intersection } from "lodash";
import { getLocalValue } from "./auth";

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length;
}

export function getAllowedRoutes(routes) {
  let roles = [];

  if (parseInt(getLocalValue("u_coaching_role")) === 0) {
    roles.push(parseInt(getLocalValue("u_role")));
  }
  roles.push(parseInt(getLocalValue("u_coaching_role")));

  const isFirstTimeLogin = getLocalValue("first_login");
  if (isFirstTimeLogin === "1") {
    roles = [];
  }

  return routes.filter(({ permission }) => {
    if (!permission) return true;
    else if (!isArrayWithLength(permission)) return true;
    else return intersection(permission, roles).length;
  });
}
